<section class="flex flex-col -m-4 bg-background">
    @if (form()) {
        <section class="flex flex-row items-center gap-10 p-4 h-8 bg-white rounded">
            <span class="text-base font-medium">{{ form()?.name }}</span>
            <span class="!p-0 max-w-xs sm:max-w-sm">
                <app-button
                    iconSize="xs"
                    [icon]="['fas', isDropDownFormListOpen() ? 'chevron-up' : 'chevron-down']"
                    [iconPosition]="IconPosition.END"
                    [label]="'countUsedInFieldInterventions' | transloco: { COUNT: fieldIntervention().length }"
                    [matMenuTriggerFor]="menu"
                    [type]="ButtonType.UNDERLINE"
                    (menuClosed)="onFormListMenuClosed()"
                    (menuOpened)="onFormListMenuOpened()" />
            </span>

            <mat-menu #menu="matMenu">
                <div class="flex flex-col max-h-64 overflow-auto">
                    @for (fieldIntervention of fieldIntervention(); track fieldIntervention.id) {
                        <span class="text-custom-extra-dark-grey py-2 px-3">
                            {{ fieldIntervention.name }}
                        </span>
                    } @empty {
                        <span class="text-custom-extra-dark-grey py-2 px-3">
                            {{ 'noFieldIntervention' | transloco }}
                        </span>
                    }
                </div>
            </mat-menu>
        </section>
        <div class="pt-2.5 rounded w-full">
            <app-field-intervention-form-category
                [currentForm]="form()"
                [isResultRequired]="false" />
        </div>
    }
</section>
